import React from 'react';
import T from 'prop-types';
import { Button } from '@acast/decibel';
import { PlusLightGlyph } from '@acast/decibel-glyphs';

const AddMarkerButton = ({ onClick }) => (
  <Button
    className="editor-controls__item-container add-marker-button"
    data-test-id="AddMarkerButton"
    title="Click here to add a new rich media marker."
    onClick={onClick}
    glyph={PlusLightGlyph}
    size="small"
    variant="primary"
  >
    Add Media
  </Button>
);

AddMarkerButton.propTypes = {
  onClick: T.func.isRequired,
};

export default AddMarkerButton;
